declare namespace $ {

	type $shm_hitalama_map_page_arrow_widgets__from_widget_shm_hitalama_map_page_arrows_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['widget_arrow_from_widget'] >
		,
		ReturnType< $shm_hitalama_map_page_arrow_widgets['from_widget'] >
	>
	type $shm_hitalama_map_page_arrow_widgets__to_widget_shm_hitalama_map_page_arrows_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['widget_arrow_to_widget'] >
		,
		ReturnType< $shm_hitalama_map_page_arrow_widgets['to_widget'] >
	>
	type $shm_hitalama_map_page_arrow_widgets__kind_shm_hitalama_map_page_arrows_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_arrows['widget_arrow_kind'] >
		,
		ReturnType< $shm_hitalama_map_page_arrow_widgets['kind'] >
	>
	export class $shm_hitalama_map_page_arrows extends $mol_view {
		widget_arrow_kind( id: any): string
		Map_page( ): $shm_hitalama_map_page
		visible( ): boolean
		widget_arrows( ): readonly($shm_hitalama_map_page_arrow_widgets)[]
		widget_arrow_from_widget( id: any): $shm_hitalama_map_widget_float
		widget_arrow_to_widget( id: any): $shm_hitalama_map_widget_float
		Widget_arrow( id: any): $shm_hitalama_map_page_arrow_widgets
	}
	
}

//# sourceMappingURL=arrows.view.tree.d.ts.map